import { render, staticRenderFns } from "./BaseItemSubGroup.vue?vue&type=template&id=282c282f"
import script from "./BaseItemSubGroup.vue?vue&type=script&lang=js"
export * from "./BaseItemSubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports